// The candidate-facing Quiz and Simulation flows share the exact same answer semantics.
// Legacy data without a multi-answer type remains single-choice.
export function correctIndices(question) {
  if (Array.isArray(question?.reponses_correctes) && question.reponses_correctes.length) {
    return question.reponses_correctes;
  }
  if (Array.isArray(question?.choices)) {
    const fromChoices = question.choices.flatMap((choice, index) => choice.is_correct ? [index] : []);
    if (fromChoices.length) return fromChoices;
  }
  return Number.isInteger(question?.reponse_correcte) ? [question.reponse_correcte] : [];
}

export function isMultiAnswer(question) {
  return question?.type === 'qcm_multiple' || question?.type_question === 'qcm_multiple' ||
    correctIndices(question).length > 1;
}

export function hasAnswer(answer) {
  return Array.isArray(answer) ? answer.length > 0 : Number.isInteger(answer);
}

export function toggleAnswer(current, index, multiple) {
  if (!multiple) return index;
  const prior = Array.isArray(current) ? current : Number.isInteger(current) ? [current] : [];
  return prior.includes(index)
    ? prior.filter((choiceIndex) => choiceIndex !== index)
    : [...prior, index].sort((a, b) => a - b);
}

export function isSelected(answer, index) {
  return Array.isArray(answer) ? answer.includes(index) : answer === index;
}

export function isAnswerCorrect(question, answer) {
  const expected = correctIndices(question);
  const selected = Array.isArray(answer) ? answer : Number.isInteger(answer) ? [answer] : [];
  if (!selected.length || selected.length !== expected.length) return false;
  const expectedSet = new Set(expected);
  return selected.every((index) => expectedSet.has(index));
}

export function answerLabels(question, answer) {
  const indices = Array.isArray(answer) ? answer : Number.isInteger(answer) ? [answer] : [];
  return indices.length
    ? indices.map((index) => question.options?.[index]).filter(Boolean).join(' ; ') || 'Non répondue'
    : 'Non répondue';
}

export function correctAnswerLabels(question) {
  return correctIndices(question).map((index) => question.options?.[index]).filter(Boolean).join(' ; ');
}

export function attemptAnswer(question, answer) {
  const indices = Array.isArray(answer) ? answer : Number.isInteger(answer) ? [answer] : [];
  if (isMultiAnswer(question)) {
    return {
      question_id: question.db_id ?? question.id,
      selected_choice_ids: indices.map((index) => question.choices?.[index]?.id).filter((id) => Number.isInteger(id)),
    };
  }
  return {
    question_id: question.db_id ?? question.id,
    selected_choice_id: question.choices?.[indices[0]]?.id ?? null,
  };
}
